import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef, ViewChildren, QueryList, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { Router } from '@angular/router';
import { WizardStepName } from 'src/app/enums/WizardStepName';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { Subject } from 'rxjs';
import { User } from 'src/app/models/user.model';
import { CloudSubscriptionService } from 'src/app/cloud-subscription/services/cloud-subscription.service';
import { ForgetPassword } from 'src/app/models/ForgetPassword.model';
import { AMERICAN_STATES, CANADIAN_STATES, COUNTRIES, COUNTRIES_CODE_LENGTH, COUNTRIES_CODES, COUNTRIES_DIAL_CODES, COUNTRY_LAST_PHONE_LENGTH, SELECTED_COUNTRIES } from 'src/app/Util/registration-utils';
import { FieldType } from 'src/app/types/user.type';
import { PasswordFields } from 'src/app/Util/constants';
import { CreateUserRequest } from 'src/app/interfaces/user.interface';
import { Company } from 'src/app/interfaces/company.interface';
import { CloudNotificationService } from 'src/app/services/cloud-notification.service';
import { CloudNotificationStyle } from 'src/app/models/cloud-notification-style.model';
import { environment } from 'src/environments/environment';
import { AuthUtils } from 'src/app/Util/auth-utils';
import { Keys, Regex } from 'src/app/Util/keys';
import { postcodeValidator, postcodeValidatorExistsForCountry } from 'postcode-validator';
import { getCode, getName } from 'country-list';
import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';
@Component({
  selector: 'app-registration-form',
  templateUrl: './registration-form.component.html',
  styleUrls: ['./registration-form.component.sass']
})

export class RegistrationFormComponent implements OnInit, AfterViewInit {

  phoneUtil = PhoneNumberUtil.getInstance();
  faUserPlus = faUserPlus;
  CountryDialCodes = COUNTRIES_DIAL_CODES;
  USAStates = AMERICAN_STATES;
  CanadaStates = CANADIAN_STATES;
  CountryCodes = COUNTRIES_CODES;
  CountryNames = COUNTRIES;
  CountryPhoneNumbers = COUNTRIES_CODE_LENGTH
  CountryCodePhoneLength = COUNTRY_LAST_PHONE_LENGTH

  disalloweSpecialCharacters = ["\\", "/", "\"", "'", "`", "!"];

  @Output() SubmitForm = new EventEmitter<CreateUserRequest>();
  @Output() hasMadeChangesToForm = new EventEmitter<boolean>();

  @Input() cloudUser: User;
  @Input() company: Company;
  @Input() secondContactDetails: User;

  @Input() AccountExistsAlready: boolean = false;
  @Input() HideButton = false;
  @Input() isFormSubmitted: Subject<boolean> = new Subject<boolean>();
  @Input() isEditing: boolean = false;
  @Input() showPassword = true;
  @Input() isFormReadOnly = false;
  @Input() readOnlyUserEmailField = false
  @ViewChild('planDetails') planDetails: ElementRef;
  @ViewChildren('newUserWorkEmail') newUserWorkEmail!: QueryList<ElementRef>;

  stepName = WizardStepName.LoginComponent;

  registrationFormGroup: FormGroup;
  isSubmitted = false;

  states: string[] = [];
  formEnabled = true;
  secondContactFormValidation = false;
  controlsChanged: boolean;
  fetchIpLocation = false;
  fillFormData = false;
  editedOnce: boolean = false;
  passwordShow: boolean = false;
  passwordConfirmShow: boolean = false;
  primaryUserRegionCode:string = ''
  secondaryUserRegionCode:string = ''

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private cloudSubscriptionService: CloudSubscriptionService,
    private readonly notificationSvc: CloudNotificationService
  ) { }
  ngAfterViewInit(): void {
    this.focusWorkEmail();
  }

  private cheackIfPhoneNumbersValid(){
    this.checkIfPhoneNumberIsValid()
    // this.checkIfSecondaryUserPhoneNumberValid()
  }

  ngOnInit(): void {

    this.registrationFormGroup = this.createRegistrationForm();

    this.listenAreaCodeAndCountryCodeChanges()

    if (!this.isEditing && !this.AccountExistsAlready) {
      this.cloudSubscriptionService.getIpLocation().subscribe(ipLocation => {
        this.registrationForm.companyAddressCountry.setValue(ipLocation.countryName);
        this.registrationForm.companyAddressCity.setValue(ipLocation.cityName);
        this.registrationForm.companyAddressState.setValue(ipLocation.regionName);
        this.registrationForm.countryCode.setValue(this.CountryDialCodes[ipLocation.countryName].split(' ').reverse()[0].split('+')[1]);
        this.registrationForm.secondContactCountryCode.setValue(this.CountryDialCodes[ipLocation.countryName].split(' ').reverse()[0].split('+')[1]);
        this.fetchIpLocation = true;
      },
        () => {
          this.fetchIpLocation = true;
        });
    } else {
      this.fetchIpLocation = true;
    }

    this.isFormSubmitted.subscribe(val => {
      this.formEnabled = !val;
    });

    this.populateRegistrationForm();
    this.onChanges();
    this.loadStates();
    this.fillFormData = true;

    this.focusWorkEmail();
  }

  private listenAreaCodeAndCountryCodeChanges(){
    this.registrationForm.areaCode?.valueChanges.subscribe(() => {
      this.registrationForm.phoneNumber?.updateValueAndValidity();
    });
    this.registrationForm.countryCode.valueChanges.subscribe(()=>{
      this.registrationForm.phoneNumber?.updateValueAndValidity();
    })
  }

  focusWorkEmail() {
    this.newUserWorkEmail?.first.nativeElement.focus();
  }


  checkIfSecondaryUserPhoneNumberValid(){
    if(this.registrationForm.secondContactPhoneNumber.value.length == 0){}
    if(this.getFullCountryName('+'+this.registrationForm.secondContactCountryCode.value) != this.registrationForm.secondContactPhoneNumber.value.length){
      this.registrationForm.secondContactPhoneNumber.setErrors({ invalidPhoneNumber: true });
      return false
    }
    this.registrationForm.secondContactPhoneNumber.setErrors(null);
    return true
  }

  private getRegionCode(phoneNo:string){
    return this.phoneUtil.getRegionCodeForNumber(this.phoneUtil.parse(`+${phoneNo}`))
  }



  get registrationForm() {
    return this.registrationFormGroup.controls;
  }

  onPasswordInput() {
    this.editedOnce = true;
  }

  onConfirmPasswordInput() {
    this.editedOnce = true;
  }

  onChanges(): void {
    this.registrationFormGroup.valueChanges.subscribe(() => {
      this.hasMadeChangesToForm?.emit(true);
    });
  }

  private customEmailValidator():ValidatorFn {
    return (control:AbstractControl):ValidationErrors | null =>{
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test(control.value) ? null : {invalidEmail:true};
    }
  }

  createRegistrationForm() {
    return this.formBuilder.group(
      {
        email: ['', [Validators.required, this.customEmailValidator(), this.noWhitespace(), Validators.maxLength(100)]],
        password: [{ value: '', disabled: !this.showPassword }, [Validators.required, Validators.minLength(8), Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z\\d\\w\\W]{8,}$'),Validators.maxLength(100)]],
        confirmPassword: [{ value: '', disabled: !this.showPassword }, Validators.required],
        firstName: ['', [Validators.required, Validators.pattern('^[a-zA-Z \u00C0-\u00FF]*$'), Validators.maxLength(50), Validators.minLength(3), this.noWhitespace(), this.minLengthWithoutWhitespace()]],
        lastName: ['', [Validators.required, Validators.pattern('^[a-zA-Z \u00C0-\u00FF]*$'), Validators.maxLength(50), Validators.minLength(3), this.noWhitespace(), this.minLengthWithoutWhitespace()]],
        jobTitle: ['', [Validators.required, Validators.maxLength(50), this.noWhitespace()]],
        countryCode: ['', [Validators.required]],
        areaCode: [''],
        phoneNumber: ['', [Validators.required,Validators.pattern(/^\d+$/),this.isValidPhone(),Validators.maxLength(15)]],

        company: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(15), this.noWhitespace(),this.disAllowCertainSpecialCharacters()]],
        companyAddressCountry: ['', [Validators.required]],
        companyAddressLineOne: ['', [Validators.required, Validators.maxLength(255), this.noWhitespace(), this.onlySpecialCharactersNotAllowed()]],
        companyAddressLineTwo: ['', [this.onlySpecialCharactersNotAllowed()]],
        companyAddressCity: ['', [Validators.required, Validators.maxLength(50), Validators.pattern('^[A-Za-z ]{0,}$'), this.onlySpecialCharactersNotAllowed()]],
        companyAddressState: ['', [Validators.required,Validators.pattern('^([A-Za-z]\\s{0,1}){0,}$'), this.noWhitespace(), Validators.maxLength(50), Validators.minLength(2), this.onlySpecialCharactersNotAllowed()]],
        companyAddressPostalCode: ['', [Validators.required,Validators.minLength(2), Validators.maxLength(50),Validators.pattern('^[A-Za-z0-9-]{3,10}$')]],
        companyUrl: ['', [Validators.required, this.noWhitespace(), Validators.pattern(Regex.companyUrlPattern), Validators.maxLength(50)]],

        secondContactFirstName: ['', [ Validators.pattern('^[a-zA-Z \u00C0-\u00FF]*$'), Validators.maxLength(50), Validators.minLength(3), this.noWhitespace(), this.minLengthWithoutWhitespace()]],
        secondContactLastName: ['', [ Validators.pattern('^[a-zA-Z \u00C0-\u00FF]*$'), Validators.maxLength(50), Validators.minLength(3), this.noWhitespace(), this.minLengthWithoutWhitespace()]],
        secondContactEmail: ['', [ Validators.email, this.noWhitespace(), this.emailIsNotSameAsPrimary(), Validators.maxLength(100)]],
        secondContactCountryCode: ['', [Validators.min(1), Validators.max(999)]],
        secondContactAreaCode: ['', [Validators.maxLength(10), Validators.minLength(2), Validators.pattern('^[0-9]{1,}$')]],
        secondContactJobTitle: ['', [ this.noWhitespace(), Validators.maxLength(50)]],
        secondContactPhoneNumber: ['', ],
      }, { validator: this.ConfirmedValidator('password', 'confirmPassword') }
    );
  }

  private secondContactValidator: ValidatorFn = (group: AbstractControl): { [key: string]: boolean } | null => {
    const firstName = group.get('secondContactFirstName');
    const lastName = group.get('secondContactLastName');
    const email = group.get('secondContactEmail');
    const countryCode = group.get('secondContactCountryCode');
    const areaCode = group.get('secondContactAreaCode');
    const jobTitle = group.get('secondContactJobTitle');
    const phoneNumber = group.get('secondContactPhoneNumber');

    const anyFieldHasValue = [
      firstName?.value,
      lastName?.value,
      email?.value,
      countryCode?.value,
      areaCode?.value,
      jobTitle?.value,
      phoneNumber?.value,
    ].some((field)=>field != null && field.toString().trim() !== '')

    if(anyFieldHasValue){
      [firstName, lastName, email, countryCode, areaCode, jobTitle, phoneNumber].forEach((control)=>{
        control?.setValidators([
          Validators.required,
          ...(control?.validator ? [control.validator] : []),
        ]);
        control?.updateValueAndValidity({ onlySelf: true });
      })
      return null
    }

    [firstName, lastName, email, countryCode, areaCode, jobTitle, phoneNumber].forEach((control)=>{
      control.clearValidators()
      control?.updateValueAndValidity({ onlySelf: true });
    })

    return null;
  }

  resetSecondContactDetails(){
    this.registrationFormGroup.get('secondContactFirstName')?.reset('');
    this.registrationFormGroup.get('secondContactLastName')?.reset('');
    this.registrationFormGroup.get('secondContactEmail')?.reset('');
    this.registrationFormGroup.get('secondContactCountryCode')?.reset('');
    this.registrationFormGroup.get('secondContactAreaCode')?.reset('');
    this.registrationFormGroup.get('secondContactJobTitle')?.reset('');
    this.registrationFormGroup.get('secondContactPhoneNumber')?.reset('');
  }

  private populateRegistrationForm(): void {

    if (this.cloudUser) {

      this.registrationForm.email.setValue(this.cloudUser.email);
      this.registrationForm.firstName.setValue(this.cloudUser.firstName);
      this.registrationForm.lastName.setValue(this.cloudUser.lastName);
      this.registrationForm.jobTitle.setValue(this.cloudUser.jobTitle);

      if (this.cloudUser.phoneNumber) {
        this.registrationForm.countryCode.setValue(this.isEditing || this.AccountExistsAlready ?
          this.cloudUser.phoneNumber?.split(/[ -]/)[0]?.replace('+', '') :
          this.cloudUser.phoneNumber?.split(/[ -]/)[0]?.replace('+', ''));

      } else {
        this.registrationForm.countryCode.setValue('');
      }

      this.registrationForm.areaCode.setValue(this.isEditing || this.AccountExistsAlready ? this.cloudUser.phoneNumber?.split(/[ -]/)[1]?.substr(0) : this.cloudUser.phoneNumber?.split(/[ -]/)[1]?.substr(0, 3));
      this.registrationForm.phoneNumber.setValue(this.isEditing || this.AccountExistsAlready ? this.cloudUser.phoneNumber?.split(/[ -]/)[2]?.substr(0) : this.cloudUser.phoneNumber?.split(/[ -]/)[1]?.substr(3));
    }

    if (this.company) {
      this.registrationForm.company.setValue(this.company.name);
      this.registrationForm.companyAddressCountry.setValue(this.company.country);
      this.registrationForm.companyAddressLineOne.setValue(this.company.address);
      this.registrationForm.companyAddressCity.setValue(this.company.city);
      this.registrationForm.companyAddressState.setValue(this.company.state);
      this.registrationForm.companyAddressPostalCode.setValue(this.company.postalCode);
      this.registrationForm.companyUrl.setValue(this.company.url);
    }



    if (this.secondContactDetails) {
      this.registrationForm.secondContactEmail.setValue(this.secondContactDetails.email);
      this.registrationForm.secondContactJobTitle.setValue(this.secondContactDetails.jobTitle);
      this.registrationForm.secondContactFirstName.setValue(this.secondContactDetails.firstName);
      this.registrationForm.secondContactLastName.setValue(this.secondContactDetails.lastName);
      this.registrationForm.secondContactCountryCode.setValue(this.secondContactDetails.phoneNumber?.split('-')[0]?.replace('+', ''));
      this.registrationForm.secondContactAreaCode.setValue(this.secondContactDetails.phoneNumber?.split('-')[1]?.substr(0));
      this.registrationForm.secondContactPhoneNumber.setValue(this.secondContactDetails.phoneNumber?.split('-')[2]?.substr(0));
    }
  }

  disAllowCertainSpecialCharacters(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value?.trim();
      if (!value) return null;

      let includes = false;
      this.disalloweSpecialCharacters.forEach(e => {
        if (value.includes(e)) includes = true;
      });

      if (includes) return { specialCharactersDisallowed: true };
      return null;
    };
  }

  getDisallowedSpecialCharacters() {
    let str = "";
    this.disalloweSpecialCharacters.forEach(e => {
      str += `${e} `
    });
    return str;
  }

  minLengthWithoutWhitespace(): ValidatorFn {
    return (control: AbstractControl) => {
      const controlValue: string = control.value;
      return controlValue != null && controlValue !== undefined && controlValue !== '' && controlValue.replace(' ', '').length < 3 ? { required: true } : null;
    };
  }

  ConfirmedValidator(password: string, confirmPassword: string) {
    return (formGroup: FormGroup) => {
      const Password = formGroup.controls[password];
      const ConfirmPassword = formGroup.controls[confirmPassword];
      if (ConfirmPassword.errors && !ConfirmPassword.errors.confirmedValidator) {
        return;
      }
      if (Password.value !== ConfirmPassword.value) {
        ConfirmPassword.setErrors({ confirmedValidator: true });
      } else {
        ConfirmPassword.setErrors(null);
      }
    }
  }

  getPhoneNumber() {
    const code = `+${this.registrationFormGroup.value.AreaCode}-${this.registrationFormGroup.value.CountryCode}-`;
    let phoneNumber = `${this.registrationFormGroup.value.PhoneNumber}`;
    phoneNumber = `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    return code + phoneNumber;
  }

  private checkIfEveryFieldInSecondaryUserEmpty():boolean{
    const firstName = this.registrationFormGroup.get('secondContactFirstName');
    const lastName = this.registrationFormGroup.get('secondContactLastName');
    const email = this.registrationFormGroup.get('secondContactEmail');
    const countryCode = this.registrationFormGroup.get('secondContactCountryCode');
    const areaCode = this.registrationFormGroup.get('secondContactAreaCode');
    const jobTitle = this.registrationFormGroup.get('secondContactJobTitle');
    const phoneNumber = this.registrationFormGroup.get('secondContactPhoneNumber');

    const anyFieldHasValue = [
      firstName?.value,
      lastName?.value,
      email?.value,
      countryCode?.value,
      areaCode?.value,
      jobTitle?.value,
      phoneNumber?.value,
    ].every((field)=>field != null && field.toString().trim() == '')

    return anyFieldHasValue
  }

  onSubmit() {
    this.registrationFormGroup.updateValueAndValidity();
    this.isSubmitted = true;
    if (this.isStateAndPostalCodeRequiredForSelectedCountry()) {
      if (this.registrationForm.companyAddressPostalCode.value === '') {
        this.registrationForm.companyAddressPostalCode.setErrors({ required: true });
      }
    }

    const primaryUser = this.initializePrimaryUser();
    const company = this.initializeCompany();
    let secondaryUser = this.initializeSecondaryUser();

    if (this.isStateAndPostalCodeRequiredForSelectedCountry()) {
      if (!this.states.includes(company.state)) {
        this.registrationForm.companyAddressState.setErrors({ required: true });
      }
    }
    if (this.getInvalidFormFields().length > 0 || this.registrationFormGroup.invalid) {
      this.scrollToFirstInvalidField();
      this.notificationSvc.removeToastNotification('register');
      this.notificationSvc.createToastNotification('register', 'User data validation failed: One or more fields are invalid.', CloudNotificationStyle.danger);
      return;
    }
    // if(this.checkIfEveryFieldInSecondaryUserEmpty()){
    //   secondaryUser = null
    // }
    this.SubmitForm.emit({ primaryUser, company, secondaryUser });
  }

  verifyComapnyPostalCode(){

    let isValid = false
    if(this.registrationForm.companyAddressPostalCode.value != '' && this.registrationForm?.companyAddressCountry?.value){
      let countryCode = this.getCountryCode()
      if(countryCode != null){
        isValid = postcodeValidator(this.registrationForm.companyAddressPostalCode.value, countryCode)
      }
    }
    if(!isValid) this.registrationForm.companyAddressPostalCode.setErrors({invalidAreaCode:true})
    else this.registrationForm.companyAddressPostalCode.setErrors(null)
    return isValid
  }

  private getFullCountryName(countryCode:string){
    return this.CountryCodePhoneLength[countryCode]
  }

  getCountryCode() {

    return getCode( this.registrationForm?.companyAddressCountry?.value) || null;
  }

  loadStates() {
    this.USAStates.forEach(Key => {
      this.states.push(Key.key);
    });

    this.CanadaStates.forEach(Key => {
      this.states.push(Key.key);
    });
  }

  InvalidControls() {
    const invalid = [];
    const controls = this.registrationForm;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid.length;
  }

  onSecondContactControlChange() {
    const secondContactControls = Object.keys(this.registrationForm).filter(key => {
      return key.startsWith('second');
    });

    const allControlsAreEmpty = secondContactControls.every(key => {
      return this.registrationForm[key].value === null ||
        this.registrationForm[key].value === undefined ||
        this.registrationForm[key].value?.trim() === '';
    });

    if (allControlsAreEmpty) {
      this.secondContactFormValidation = false;
    } else {
      this.secondContactFormValidation = true;
    }

    secondContactControls.forEach(key => {
      this.registrationForm[key].updateValueAndValidity({ onlySelf: true });
    });
  }

  noWhitespace(): ValidatorFn {
    return (control: AbstractControl) => {
      const controlValue: string = control.value;

      // tslint:disable-next-line: max-line-length
      return controlValue != null && controlValue !== undefined && controlValue !== '' && controlValue.trim().length === 0 ? { required: true } : null;
    };
  }

   checkIfPhoneNumberIsValid(){
    if(this.getFullCountryName('+'+this.registrationForm.countryCode.value) != this.registrationForm.phoneNumber.value.length){
      this.registrationForm.phoneNumber.setErrors({ invalidPhoneNumber: true });
      return false
    }
    this.registrationForm.phoneNumber.setErrors(null);
    return true
  }


  emailIsNotSameAsPrimary(): ValidatorFn {
    return (control: AbstractControl) => {
      if (this.cloudUser?.email) {
        return control.value === this.cloudUser.email ? { emailIsSame: true } : null;
      }
      return null;
    };
  }

  onlySpecialCharactersNotAllowed(): ValidatorFn {
    // tslint:disable-next-line: max-line-length
    const pattern = new RegExp('^([\\`|\\~|\\!|\\@|\\#|\\$|\\%|\\^|\\&|\\*|\\(|\\)|\\+|\\=|\\[|\\{|\\]|\\}|\\||\\\\|\\\'|\\<|\\,|\\.|\\>|\\?|\\/|\\"|\\;|\\:]{0,}\\s{0,}){0,}$');
    return (control: AbstractControl) => {
      const val: string = control.value;

      return val === '' ? null : (pattern.test(val) ? { containsSpecialCharactersOnly: true } : null);
    };
  }

  getCompanyAddressStateDisplayValue(): string {
    if (this.company.country && this.company.state) {
      if (this.company.country === 'United States') {
        return this.USAStates.find(state => {
          return state.key === this.company.state;
        }).value;
      } else if (this.company.country === 'Canada') {
        return this.CanadaStates.find(state => {
          return state.key === this.company.state;
        }).value;
      }

      return this.company.state;
    }

    return '';
  }

  resetPassword() {
    var encoded_link = AuthUtils.encodeToBase64(this.cloudUser.email)
    var encoded_action = AuthUtils.encodeToBase64(Keys.update_password);
    this.router.navigate([environment.routes.reset_password], { queryParams: { code: encoded_link, action: encoded_action }})
  }

  isStateAndPostalCodeRequiredForSelectedCountry() {
    const { companyAddressCountry } = this.registrationForm;
    return SELECTED_COUNTRIES.includes(companyAddressCountry.value);
  }

  initializePrimaryUser(): User {
    const { firstName, lastName, countryCode, areaCode, phoneNumber, jobTitle, email, password } = this.registrationForm;
    const primaryUser: User = {
      firstName: firstName.value,
      lastName: lastName.value,
      phoneNumber: `+${countryCode.value}-${areaCode.value}-${phoneNumber.value}`,
      jobTitle: jobTitle.value,
      email: email.value,
      password: this.showPassword ? password.value : this.cloudUser?.password,
      primaryUserEmail: '',
      companyName: '',
      companyUrl: '',
      companyCity: '',
      companyCountry: '',
      companyState: '',
      companyDetails:null
    }
    return primaryUser;
  }

  initializeSecondaryUser(): User {
    const { secondContactFirstName, secondContactLastName, secondContactCountryCode, secondContactAreaCode, secondContactPhoneNumber, secondContactJobTitle, secondContactEmail } = this.registrationForm;
    const secondaryUser: User = {
      firstName: secondContactFirstName.value || '',
      lastName: secondContactLastName.value || '',
      phoneNumber: `+${secondContactCountryCode.value || ''}-${secondContactAreaCode.value || ''}-${secondContactPhoneNumber.value || ''}`,
      jobTitle: secondContactJobTitle.value || '',
      email: secondContactEmail.value || '',
      password: '',
      primaryUserEmail: '',
      companyName: '',
      companyUrl: '',
      companyCity: '',
      companyCountry: '',
      companyState: '',
      companyDetails: null
    };
    return secondaryUser;
  }

  initializeCompany(): Company {
    const { company, companyAddressLineOne, companyAddressLineTwo, companyAddressCity, companyAddressState, companyAddressPostalCode, companyAddressCountry, companyUrl } = this.registrationForm;
    const userCompany: Company = {
      name: company.value.trim(''),
      address: `${companyAddressLineOne.value} ${companyAddressLineTwo.value}`,
      city: companyAddressCity.value,
      state: companyAddressState.value,
      postalCode: companyAddressPostalCode.value,
      country: companyAddressCountry.value,
      url: companyUrl.value
    }
    return userCompany;
  }

  getInvalidFormFields(): string[] {
    const invalidControls = [];
    const controls = this.registrationForm.controls;

    for (const controlName in controls) {
      const control = controls[controlName];

      if (control.invalid) {
        invalidControls.push(controlName);
      }
    }

    return invalidControls;
  }

  scrollToFirstInvalidField(): void {
    const invalidControls = this.getInvalidFormFields();

    if (invalidControls.length > 0) {
      const firstInvalidControlName = invalidControls[0];
      const invalidControlElement = document.querySelector(`[formControlName=${firstInvalidControlName}]`);

      if (invalidControlElement) {
        invalidControlElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }

  togglePasswordVisibility(field: FieldType): void {
    if (this.isFormReadOnly) return;

    if (field === PasswordFields.Password) {
      this.passwordShow = !this.passwordShow;

    } else if (field === PasswordFields.Confirm_Password) {
      this.passwordConfirmShow = !this.passwordConfirmShow;
    }
  }



  //Code copied straight from Alachisoft Website phone validaiton
  isValidPhone(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;

      const form = control.parent;
      if (!form) return null;

      const countryCode = form.get('countryCode')?.value;
      const areaCode = form.get('areaCode')?.value;
      const number = form.get('phoneNumber')?.value;


      if (!countryCode || !number) return { inValidPhone: true };


      if (countryCode == "1") {
        if (number.substr(0, 7) == "5551212" || number.substr(0, 3) == "555" || number.substr(0, 4) == "1212")
          return { inValidPhone: true };
        if (areaCode.length == 3) {

          if (areaCode.charAt(0) == '0' || areaCode.charAt(0) == '1') {
            return { inValidPhone: true };
          }
          if (areaCode.charAt(1) == '9') {
            return { inValidPhone: true };
          }
          if (number.charAt(0) == '0' || number.charAt(0) == '1') {
            return { inValidPhone: true };
          }
          if (number.charAt(1) == '1' && number.charAt(2) == '1') {
            return { inValidPhone: true };
          }
        }
        else {
          return { inValidPhone: true };
        }
      }

      if (countryCode == "44") {
        // if (areaCode == '169 77' && number.length !== 4) return { inValidPhone: true };
        // if (areaCode == '500' && number.length !== 6) return { inValidPhone: true };
        // if (areaCode[0] == '1' && areaCode.length === 5 && number.length !== 5) return { inValidPhone: true };
        // if (areaCode[0] == '1' && areaCode.length === 3 && number.length !== 7) return { inValidPhone: true };
        // if (areaCode[0] == '2' && areaCode.length === 2 && number.length !== 8) return { inValidPhone: true };
        // if (areaCode[0] == '3' && areaCode.length === 3 && number.length !== 7) return { inValidPhone: true };
        // if (areaCode[0] == '5' && areaCode.length === 2 && number.length !== 8) return { inValidPhone: true };
        // if (areaCode[0] == '7' && areaCode.length === 2 && number.length !== 8) return { inValidPhone: true };
        // if (areaCode == '7624' && areaCode.length === 4 && number.length !== 6) return { inValidPhone: true };
        // if (areaCode[0] == '7' && areaCode.length === 4 && number.length !== 6) return { inValidPhone: true };
        // if (areaCode[0] == '8' && areaCode.length === 3 && number.length !== 7) return { inValidPhone: true };
        // if (areaCode[0] == '9' && areaCode.length === 3 && number.length !== 7) return { inValidPhone: true };
      }

      if (this.allRepeatingChars(number)) return { inValidPhone: true };

      const num = number.replace(/\s|-/g, "");
      if (isNaN(Number(num))) return { inValidPhone: true };

      // Avoid common fake numbers
      if (number.startsWith("123456789") || number.startsWith("1234567")) return { inValidPhone: true };

      return null;
    };
  }


allRepeatingChars(str) {
	let char = str.charAt(0);
	let repeating = true;
	for (let i = 1; i < 7; i++) {
		if (str.charAt(i) != char) {
			repeating = false;
			break;
		}
	}

	return repeating;
}


}
